import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';
import { firstDayofYear, lastDayofYear } from '../../utils/calcDatetime';

const [LIST_CHACE_FAILS, LIST_CHACE_FAILS_SUCCESS, LIST_CHACE_FAILS_FAILURE] =
  createRequestActionTypes('chance/LIST_CHANCE_FAILS');

export const listChanceFails = createAction(
  LIST_CHACE_FAILS,
  (searchData) => searchData,
);
const listChanceFailsSaga = createRequestSaga(
  LIST_CHACE_FAILS,
  chanceApi.getBaseChances,
);

const SET_FAILS_FITERS = 'chance/SET_FAILS_FITERS';
export const setFailsFilters = createAction(
  SET_FAILS_FITERS,
  (filters) => filters,
);

const RESET_FAILS_FILTERS = 'chance/RESET_FAILS_FILTERS';
export const resetFailsFilters = createAction(RESET_FAILS_FILTERS);

export function* chanceFailsSaga() {
  yield takeLatest(LIST_CHACE_FAILS, listChanceFailsSaga);
}

const initialState = {
  totals: null,
  chances: null,
  error: null,
  defaultFilters: {
    useYn: 'N',
    searchGrade: '',
    searchPrjTyp: '',
    searchPrjImpt: '',
    searchKeyword: 'cstNm',
    searchWords: '',
    searchStrtDt: firstDayofYear,
    searchEndDt: lastDayofYear,
  },
};

const chanceFails = handleActions(
  {
    [LIST_CHACE_FAILS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      totals: data?.totals,
      chances: data.list.map((chance) => ({
        id: chance.prjUuid,
        prjSeq: chance.prjSeq,
        prjUuid: chance.prjUuid,
        prjNo: chance.prjNo,
        cstNm: chance.cstNm,
        cstStatus: chance.cstStatus,
        cstGrade: chance.cstGrade,
        prjTyp: chance.prjTyp,
        // partnerInc: chance.partnerInc,
        // chargeNm: chance.chargeNm,
        // chargeEml: chance.chargeEml,
        // chargeTel: chance.chargeTel,
        chanceTyp: chance.chanceTyp,
        prjImpt: chance.prjImpt,
        bugetYn: chance.bugetYn,
        // partnerTyp: chance.partnerTyp,
        incTyp: chance.incTyp,
        // solutionTyp: chance.solutionTyp,
        productYn: chance.productYn,
        vendorCmp: chance.vendorCmp,
        vendorCmpNm: chance.vendorCmpNm,
        // vendorEmp: chance.vendorEmp,
        // vendorEmpNm: chance.vendorEmpNm,
        expBenefitRate: chance.expBenefitRate,
        expSales: chance.expSales,
        expBuy: chance.expBuy,
        expDay: chance.expDay,
        // pmUsr: chance.pmUsr,
        // pmNm: chance.pmNm,
        // plUsr: chance.plUsr,
        // plNm: chance.plNm,
        // techUsr: chance.techUsr,
        // techNm: chance.techNm,
        costYn: chance.costYn,
        mtnFreeTor: chance.mtnFreeTor,
        mtnPayTor: chance.mtnPayTor,
        mtnFreeSt: chance.mtnFreeSt,
        mtnFreeEd: chance.mtnFreeEd,
        mtnPaySt: chance.mtnPaySt,
        mtnPayEd: chance.mtnPayEd,
        totalPurchase: chance?.totalPurchase,
        totalSales: chance?.totalSales,
        totalProfit: chance?.totalProfit,
        totalMargin: chance?.totalMargin,
        useYn: chance.useYn,
        crtDptNm: chance.crtDptNm,
        crtNm: chance.crtNm,
        crtGradeNm: chance.crtGradeNm,
        failTxt: chance?.failTxt,
        crtDt: chance.crtDt,
        cngNm: chance.cngNm,
        cngDt: chance.cngDt,
      })),
      error: null,
    }),
    [LIST_CHACE_FAILS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [RESET_FAILS_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_FAILS_FITERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default chanceFails;
